import { atom } from 'jotai'

const getSubdomainFromUrl = (): string | null => {
  if (typeof window === 'undefined') return null

  const safeDomain = import.meta.env.VITE_SAFE_DOMAIN
  if (!safeDomain) return null

  const hostname = window.location.hostname
  if (!hostname.endsWith(safeDomain)) return null

  const subdomain = hostname.substring(0, hostname.indexOf(safeDomain) - 1)
  return subdomain || null
}

// Initialize with current subdomain immediately
export const subdomainAtom = atom<string | null>(getSubdomainFromUrl())

export const isSubdomainModeAtom = atom((get) => {
  const subdomain = get(subdomainAtom)
  return subdomain !== null && subdomain !== ''
})
